import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/compat/database';
import { UserService } from './user.service';
import { map } from 'rxjs/operators';
import { OrderService } from './order.service';

@Injectable()
export class ArticleAccountingService {
    private articleAccountingsRef: AngularFireList<any>;
    private articleVatCategoriesRef: AngularFireList<any>;
    private accountsRef: AngularFireList<any>;
    articleAccountings: BehaviorSubject<ArticleAccounting[]> = new BehaviorSubject([]);
    articleVatCategories: BehaviorSubject<ArticleVatCategory[]> = new BehaviorSubject([]);
    accounts: BehaviorSubject<any> = new BehaviorSubject(null);
    subscriptions = new Subscription();
    constructor(private afDatabase: AngularFireDatabase, private userService: UserService) {
        this.userService.selectedUnit$.subscribe(x => {
            if (!x) {
                this.articleAccountingsRef = null;
                this.articleVatCategoriesRef = null;
                return;
            }
            this.subscriptions.unsubscribe();
            this.subscriptions = new Subscription();
            this.accountsRef = this.afDatabase.list(
                `adminApp/clients/${x.routeName}/settings/accountingTemplates/accounts`
            );
            let accountSub = this.accountsRef.valueChanges().subscribe(x => this.accounts.next(x));
            this.subscriptions.add(accountSub);

            this.articleAccountingsRef = this.afDatabase.list(
                `adminApp/clients/${x.routeName}/settings/vat/articleAccountings`
            );
            this.articleVatCategoriesRef = this.afDatabase.list(
                `Categories`
            );
            let articleAccSub = this.articleAccountingsRef
                .snapshotChanges()
                .pipe(
                    map(changes =>
                        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
                    )).subscribe(x => this.articleAccountings.next(x));
            this.subscriptions.add(articleAccSub);

            let avcSub = this.articleVatCategoriesRef
                .snapshotChanges()
                .pipe(
                    map(changes =>
                        changes.map(c => ({
                            key: c.payload.key,
                            vatPercent: c.payload.val().moms,
                            name: c.payload.val().name,
                            hasAlcohol: c.payload.val().hasAlcohol,
                            translationId: ""
                        }))
                    )).subscribe(x => this.articleVatCategories.next(x));
            this.subscriptions.add(avcSub);
        });
    }
    async saveAccounts(accounts) {
        accounts.forEach(element => {
            this.updateArticleAccounting(element);
        });
        return true;
    }
    updateArticleAccounting(articleAccounting: ArticleAccounting) {
        return this.articleAccountingsRef.update(articleAccounting.key, articleAccounting);
    }
    deleteArticleAccounting(articleAccounting: ArticleAccounting) {
        return this.articleAccountingsRef.remove(articleAccounting.key);
    }
    addArticleAccounting(articleAccounting: ArticleAccounting) {
        var obj: ArticleAccounting = {
            name: "Ny kontering",
            tax: 0,
            type: "wares",
            isUserCreated: true,
            accounts: [
                { name: "Momspliktig", accountNumber: "", property: "taxDuty" },
                { name: "Momsfri", accountNumber: "", property: "taxFree" }
            ],
            externalId: ""
        };

        let key = this.articleAccountingsRef.push(obj).key;
        obj.key = key;
        return obj;
    }
}
export class ArticleAccounting {
    key?: string;
    name: string;
    tax: number;
    isUserCreated?: boolean;
    type: string;
    accounts: Account[];
    externalId: string;
    takeawayFood?: boolean;
    takeawayDrinks?: boolean;
}
export class Account {
    name: string;
    property: string;
    accountNumber: string;
}
export class ArticleVatCategory {
    key: string;
    hasAlcohol: boolean;
    vatPercent: number;
    name: string;
    translationId: string;
}
